module.exports = __webpack_public_path__ + "static/media/x4_icon.1c4820ff.svg";